import { jsx as l } from "react/jsx-runtime";
const t = (a) => /* @__PURE__ */ l(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ...a,
    children: /* @__PURE__ */ l(
      "path",
      {
        fill: "currentcolor",
        d: "M14.875 4.141A3 3 0 0 0 12 2l-.176.004-.182.017a3 3 0 0 0-2.562 2.29l-.01.043-.248.146A8 8 0 0 0 5 10.954L5 13.924l-.021.143a3 3 0 0 1-1.472 2.063C2.613 16.636 2.972 18 4 18h12v-2a3 3 0 0 1 3-3v-2l-.02-.289-.027-.287a8.01 8.01 0 0 0-4.024-6.069l-.008-.043zM14.235 19c.865 0 1.322 1.024.745 1.668A4 4 0 0 1 12 22a4 4 0 0 1-2.98-1.332c-.552-.616-.158-1.579.634-1.661l.11-.006zM20 16a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zM20 22a1 1 0 1 0-2 0v.01a1 1 0 1 0 2 0z"
      }
    )
  }
);
export {
  t as default
};
